import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
import { FlameWatermark } from './ui/FlameWatermark';
export function WorkWithMe() {
  const programs = [{
    title: 'Atelierele Online Periodice',
    subtitle: '4 ateliere live lunar, cu tematici noi în fiecare lună',
    image: 'https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=800&h=250&fit=crop&crop=center',
    benefits: ['Un atelier live săptămânal în Zoom', 'Fișe de lucru și exerciții practice', 'Acces la sesiunile anterioare înregistrate', 'Comunitate privată pentru întrebări zilnice', 'Tematică nouă în fiecare lună'],
    cta: 'Vreau Atelierele',
    href: 'https://wa.me/40744377234'
  }, {
    title: 'Programele de Grup',
    subtitle: 'Dinamica stilurilor de personalitate și mentorare de grup',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&h=250&fit=crop&crop=faces',
    benefits: ['Studiul dinamicii stilurilor de personalitate', 'Sesiuni live în grup restrâns pe Zoom', 'O sesiune individuală VIP 1-1 cu Raport DISC de 30 pagini', 'O sesiune de experiențială de recunoaștere a stilului', 'Metoda A.E.R. aplicată pas cu pas'],
    cta: 'Vreau Programele de Grup',
    href: 'https://wa.me/40744377234'
  }, {
    title: 'Coaching & Mentorare 1 la 1',
    subtitle: 'Sesiuni individuale, personalizate pentru tine',
    image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=800&h=250&fit=crop&crop=center',
    benefits: ['Program complet 1 la 1 personalizat pentru tine', 'Atenție VIP, dedicată exclusiv situației tale', 'Flexibilitate în programarea sesiunilor tale', 'Raport DISC și analiză comportamentală aprofundată', 'Ghidare confidențială în decizii importante'],
    cta: 'Vreau Coaching & Mentorare 1 la 1',
    href: 'https://wa.me/40744377234'
  }, {
    title: 'Cursuri Online',
    subtitle: 'Învață în ritmul tău, oricând din platforma digitală',
    image: 'https://cdn.magicpatterns.com/uploads/bSAA2yXRwsrR96WPpUowBv/Stela_Cursuri.png',
    benefits: ['Acces instant la toate lecțiile înregistrate', 'Videoclipuri, fișe de lucru și exerciții', 'Înveți în ritmul tău, de oriunde', 'Comunitate pentru întrebări și clarificări', 'Acces instant la resurse de calitate'],
    cta: 'Vezi Cursurile Online',
    href: 'https://stelalucutaconsulting.com/primiipasi'
  }];
  return <section className="bg-plum py-12 md:py-20 relative overflow-hidden" data-id="element-341">
      <FlameWatermark className="bottom-10 right-10 w-96 h-96 opacity-10 text-cream" data-id="element-342" />

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-343">
        <FadeIn data-id="element-344">
          <div className="text-center max-w-[720px] mx-auto mb-16 md:mb-24" data-id="element-345">
            <h2 className="text-[32px] md:text-[48px] font-medium leading-[1.15] text-cream mb-6" data-id="element-346">
              4 moduri să lucrezi cu mine
            </h2>
            <p className="text-[16px] md:text-[18px] text-cream/80 leading-[1.65]" data-id="element-347">
              De la ateliere lunare până la Coaching & Mentorare 1 la 1
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-348">
          {programs.map((program, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-349">
              <div className="bg-cream-alt rounded-[16px] overflow-hidden shadow-card hover:shadow-card-hover hover:-translate-y-2 transition-all duration-300 h-full flex flex-col" data-id="element-350">
                {/* Service Image */}
                <div className="w-full h-[200px] md:h-[250px] overflow-hidden" data-id="element-351">
                  <img src={program.image} alt={program.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-352" />
                </div>

                <div className="p-8 md:p-10 flex flex-col flex-grow" data-id="element-353">
                  <div className="mb-8" data-id="element-354">
                    <h3 className="text-[24px] font-semibold mb-3" data-id="element-355">
                      {program.title}
                    </h3>
                    <h4 className="text-[16px] font-medium text-warmgray" data-id="element-356">
                      {program.subtitle}
                    </h4>
                  </div>

                  <div className="w-full h-[1px] bg-plum-muted mb-8" data-id="element-357"></div>

                  <ul className="space-y-4 mb-10 flex-grow" data-id="element-358">
                    {program.benefits.map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-359">
                        <CheckCircle2 className="w-6 h-6 text-plum shrink-0 mt-0.5" strokeWidth={2} data-id="element-360" />
                        <span className="text-[16px] text-plum-light leading-[1.5]" data-id="element-361">
                          {benefit}
                        </span>
                      </li>)}
                  </ul>

                  <a href={program.href} target="_top" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-8 py-4 rounded-lg font-poppins font-semibold text-[16px] transition-all duration-200 hover:scale-[1.02] cursor-pointer no-underline bg-orange text-white hover:bg-orange-hover hover:shadow-btn-orange" data-id="element-362">
                    {program.cta}
                  </a>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}